module.exports = __webpack_public_path__ + "img/building7.44e166e3.jpg";